/**
 * RemoteTable persiste los filtros de columna (pueden tener nombres de pacientes): no se dejan en el navegador.
 * `tableId` es el `idTable` de la tabla.
 */
export function clearPersistedTableState(tableId: string) {
  for (const storage of [window.localStorage, window.sessionStorage]) {
    try {
      storage.removeItem(tableId)
      storage.removeItem(`mobileFilter_${tableId}`)
    } catch {
      // Sin acceso al storage: no hay nada que limpiar
    }
  }
}

/** Descarga un blob como archivo. */
export function downloadBlob(blob: Blob, fileName: string) {
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.URL.revokeObjectURL(url)
}
